module.exports = __webpack_public_path__ + "img/spice-money-bankingservices.e6590f08.png";